import { isSupportedLocale } from 'shared/utils/is-supported-locale'

interface ResolvedLocale {
  localeInPath?: string
  hasLocaleInPath: boolean
}

export const resolveLocaleInPath = (path: string): ResolvedLocale => {
  if (!path) return { localeInPath: undefined, hasLocaleInPath: false }

  const [firstSegment] = path.split('/').filter(Boolean)
  if (!firstSegment) return { localeInPath: undefined, hasLocaleInPath: false }

  if (isSupportedLocale(firstSegment)) {
    return { localeInPath: firstSegment, hasLocaleInPath: true }
  }

  return { localeInPath: undefined, hasLocaleInPath: false }
}
